module.exports = __webpack_public_path__ + "img/brightness-low.bfffbfeb.svg";